<template>
  <div v-if="shopData" class="wrap">
    <van-list
      class="van-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadMore"
      :immediate-check="false"
    >
      <!-- 主图轮播 -->
      <div class="section">
        <div class="shopName">{{ shopData.shopName }}</div>
        <swiper :options="swiperOptions" class="swiper">
          <swiper-slide
            class="swiper-item"
            v-for="(item, index) in shopData.shopSitePageResources"
            :key="index"
          >
            <div class="img-box" @click="imgpreview(index)">
              <img :src="item.imageUrl" alt="" />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="content">
        <div class="lItem">
          <div class="logo">
            <img :src="shopData.logoUrl" alt="" />
            <div class="totalCount">
              参展商品 &nbsp;<span>{{ totalCount }}</span>
            </div>
          </div>
          <shopinfs :data="shopData"></shopinfs>
        </div>
        <div class="rItem">
          <goodsList :data="list"></goodsList>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { ImagePreview } from 'vant';
import { getShopSiteView, getShopGoodsList } from '@/api/index';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

import shopinfs from './common/shopinfos';
import goodsList from './common/goodsLis';
export default {
  components: {
    swiper,
    swiperSlide,
    shopinfs,
    goodsList,
  },
  inject: ['reload'],
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination', //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
      },
      shopData: null,
      totalCount: null,
      loading: false,
      finished: false,
      shopId: null,
      list: [],
      page: {
        size: 10,
        index: 1,
      },
    };
  },
  created() {
    this.shopId = this.$route.params.id || '1130319276834578432';
    this.init();
  },
  methods: {
    init() {
      let obj = { shopId: this.shopId };
      getShopSiteView(obj)
        .then(res => {
          console.log(res);
          this.shopData = res.data;
          document.title = res.data.shopName;
          window.bldewbPhone = res.data.phone;
          return getShopGoodsList(obj);
        })
        .then(r => {
          this.totalCount = r.data.totalCount;
          this.loadMore();
        });
    },
    imgpreview(index) {
      let arr = [];
      this.shopData.shopSitePageResources.map(item => {
        arr.push(item.imageUrl);
      });
      ImagePreview({
        images: arr,
        startPosition: index,
        closeable: true,
      });
    },
    loadMore() {
      this.loading = true;
      this.getlist();
    },
    getlist() {
      let obj = { shopId: this.shopId, page: this.page };
      getShopGoodsList(obj).then(response => {
        let newList = response.data.list;
        this.list = this.list ? this.list.concat(newList) : newList;
        this.loading = false;
        this.page = response.data.next;
        if (this.list.length >= response.data.totalCount) {
          this.finished = true;
        }
      });
    },
  },
  beforeMount() {
    window.addEventListener('orientationchange', () => {
      window.location.href =
        window.location.origin +
        '/#/index/' +
        this.$route.params.id +
        '?item=' +
        new Date().getTime();
    });
  },
};
</script>
<style>
.van-list {
  height: 100%;
}
.swiper .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
}
.swiper .swiper-pagination-bullet-active {
  background: #333;
  border: 1px solid #fff;
}
</style>
<style lang="less" scoped>
.section {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  .shopName {
    position: absolute;
    left: 30px;
    top: 20px;
    min-width: 176px;
    padding: 0 16px;
    z-index: 99;
    height: 50px;
    line-height: 50px;
    background: rgba(0, 0, 0, 0.7);
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
  }
  .swiper,
  .swiper-item,
  .img-box {
    width: 100%;
    height: 320px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.content {
  padding: 0 20px;
  display: flex;
  .lItem {
    width: 240px;
    margin-right: 20px;
    height: 900px;
    position: sticky;
    top: 0;
    .logo {
      width: 100%;
      height: 178px;
      margin-bottom: 20px;
      background: #fff;
      padding-top: 20px;
      // position: sticky;
      // top: 0px;
      img {
        display: block;
        margin: 0 auto;
        width: 100px;
        height: 100px;
        object-fit: contain;
        margin-bottom: 20px;
      }
      .totalCount {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        span {
          font-weight: 500;
          color: #222222;
        }
      }
    }
  }
  .rItem {
    flex: 1;
    background: #fff;
    // height: calc(100vh - 340px);
    padding: 20px;
    padding-top: 0;
    // height: 100%;
  }
}
</style>
